import { Injectable, NgZone, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { HubConnection } from '@microsoft/signalr';

import { PairingCompletedEvent } from '@era/locations-sdk';
import { LocationsHubService } from '@rocksoft/shared';
import { PairingStoreActions } from '../sub-features/device-pairing/pairing-store';

@Injectable()
export class PairingSignalR {
  private readonly zone = inject(NgZone);
  private readonly store = inject(Store);
  private readonly locationsHubService = inject(LocationsHubService);
  private readonly hubConnection: HubConnection;

  constructor() {
    this.hubConnection = this.locationsHubService.hubConnection;
    this.initialize();
  }

  initialize() {
    this.hubConnection.on('onPairingCompleted', (pairingCompletedEvent: PairingCompletedEvent) => {
      const challenge = pairingCompletedEvent.pairingRequest?.challenge;
      if (challenge) {
        this.zone.run(() => {
          this.store.dispatch(
            PairingStoreActions.PairingSignalRActions.enrollmentCompleted({
              challenge: challenge,
            })
          );
        });
      }
    });
  }
}
